module.exports = __webpack_public_path__ + "img/logo.53be9ac1.png";